import script from "./ClearButton.vue?vue&type=script&setup=true&lang=ts"
export * from "./ClearButton.vue?vue&type=script&setup=true&lang=ts"

import "./ClearButton.vue?vue&type=style&index=0&id=6a914c28&scoped=true&lang=css"

import exportComponent from "/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6a914c28"]])

export default __exports__